import { configureStore } from "@reduxjs/toolkit";
import { injectStore } from "../api";
import productsSlice from "./slices/products/slice";
import ordersSlice from "./slices/orders/slice";
import messagesSlice from "./slices/messages/slice";
import cartSlice from "./slices/cart/slice";
import authSlice from "./slices/auth/slice";
import userSlice from "./slices/user/slice";
import couponsSlice from "./slices/coupons/slice";

import { loadState, saveState } from "./constants";

const persistedState = {
  cartInfo: loadState() || undefined,
};

const store = configureStore({
  reducer: {
    authInfo: authSlice,
    userInfo: userSlice,
    productsInfo: productsSlice,
    ordersInfo: ordersSlice,
    cartInfo: cartSlice,
    messagesInfo: messagesSlice,
    couponsInfo: couponsSlice,
  },
  preloadedState: persistedState,

  devTools: false,
});

store.subscribe(() => {
  saveState(store.getState().cartInfo);
});

injectStore(store);

export default store;
